import { LazyImage } from '@ui/common/lazy-image.tsx';
import { Button, Skeleton } from '@heroui/react';

export interface CategoryCardProps {
  image?: string;
  title?: string;
  isLoading?: boolean;
  onPress?: () => void;
  isSquare?: boolean;
  className?: string;
}

export const CategoryCard = ({
  image = '/product_placeholder.jpg',
  title = 'Название товара',
  isLoading,
  onPress,
  isSquare = true,
  className = '',
}: CategoryCardProps) => {
  const squareClass = isSquare
    ? 'aspect-square'
    : 'flex flex-row items-center justify-end';
  return (
    <Skeleton
      className={`max-w-80 lg:w-auto flex-shrink-0 max-h-80 snap-center rounded-xl ${isSquare ? 'aspect-square' : ''} ${className}`}
      isLoaded={!isLoading}
    >
      <Button
        fullWidth
        disableRipple
        variant="light"
        radius="lg"
        onPress={onPress}
        className={`${squareClass} relative max-w-80 max-h-80 h-full p-0 bg-[#F6F6F6] data-[hover=true]:bg-[#F6F6F6]`}
      >
        <div className={isSquare ? '' : 'h-24 w-24 lg:h-[140px] lg:w-[140px]'}>
          <LazyImage src={image} />
        </div>

        <div className={`absolute left-3 top-3 ${isSquare ? 'max-w-20' : ''}`}>
          <p className="text-sm text-[#222222] text-wrap text-left break-all line-clamp-3 overflow-ellipsis">
            {title}
          </p>
        </div>
      </Button>
    </Skeleton>
  );
};
